import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'pp-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  readonly size = input<'xs' | 'lg'>('lg');
}
